const Axios = require('axios')
const axios = Axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:3001/'
})
export default axios
